(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('historicoAfericoes', HistoricoAfericoes);

  function HistoricoAfericoes() {
    return {
      restrict: 'E',
      controller: 'HistoricoAfericoesWrapperCtrl',
      controllerAs: 'wrap',
      templateUrl: 'views/propriedade/historico-afericoes.html'
    };
  }
}());
